import { Modal } from 'bootstrap';
import { connect } from 'react-redux';
import Loader from "../../../components/ui/Loader/Loader";
import Ax from "../../../components/hoc/Ax";
import AppBaseComponent from '../../../components/AppBaseComponent';
import { HRM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import HttpAPICall from '../../../services/HttpAPICall';
import { toast } from 'react-toastify';
import moment from 'moment';
import DatePicker from "react-datepicker";
import TapIcon from '../../../services/TapIcon';

class EmployeeFamilyModal extends AppBaseComponent {

    constructor () {
        super();

        this.familyFormInit   =   {
            name                    :   '',
            relationship            :   '',
            dob                     :   '',
        }
        
        this.state  =   {
            emp_id              :   '',
            familyForm          :   {...this.familyFormInit},
            loading_form_data   :   false,
            saveFormSubmitting  :   false,
            type                :   'Add',
            family_id           :   '',
        }

        this.emp_family_url = HRM_API_BASE_URL_2 + '/employee_family';
        this.emp_family_detail_url = HRM_API_BASE_URL_2 + '/employee_family/detail/:id';

    }

    componentDidMount () {
        this.familyModal  =   new Modal(document.getElementById('familyModal'), {keyboard: false, backdrop :false});
    }

    modalHandle = (type, id = null) => {
        this.familyModal.show();
        this.setState({
            emp_id : this.props.emp_id,
            loading_form_data : true,
            type
        });

        if(type === 'Edit') {
            HttpAPICall.withAthorization('GET', this.emp_family_detail_url.replace(':id', id), this.props.access_token, {}, {}, (response) => {
                const data = response.data;
                this.setState({
                    family_id : id,
                    familyForm : {
                        name : data.name ? data.name : '',
                        relationship : data.relationship ? data.relationship : '',
                        dob : data.dob ? data.dob : ''
                    }
                });
           }).then(() => this.setState({ loading_form_data: false }));
        }else {
            setTimeout(() => {
                this.setState({loading_form_data : false})
            }, 200);
        }

    }

    submitForm = (e) => {
        e.preventDefault();
        let  frmData = {...this.state.familyForm, employee_id : this.state.emp_id};
        this.setState({ saveFormSubmitting: true });

        if(this.state.type === 'Edit') {
            frmData = {...frmData, id : this.state.family_id};
            HttpAPICall.withAthorization('PUT', this.emp_family_url, this.props.access_token, {}, { ...frmData }, (response) => {
                toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                this.familyModal.hide();
                this.setState({familyForm : {...this.familyFormInit}})
                this.props?.listLoading();
           }).then(() => this.setState({ saveFormSubmitting: false }));
        }else {
            HttpAPICall.withAthorization('POST', this.emp_family_url, this.props.access_token, {}, { ...frmData }, (response) => {
                 toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                 this.familyModal.hide();
                 this.setState({familyForm : {...this.familyFormInit}})
                 this.props?.listLoading();
            }).then(() => this.setState({ saveFormSubmitting: false }));
        }

    }

    render () {
        return (
            <div className="modal fade" id="familyModal" tabIndex="-1">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="editEmployeeModalLabel">{this.state.type} Family Detail</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        {
                            this.state.loading_form_data 
                            ?
                            <Loader/>
                            :
                            <Ax>
                                <div className="modal-body">
                                    <form id="family-form" onSubmit={this.submitForm}>
                                        <div className="row align-items-center my-3">
                                            <div className="col-sm-2">
                                                <label htmlFor="name" className="form-label require">Name</label>
                                            </div>
                                            <div className="col-sm-4">
                                                <input
                                                    name="name"
                                                    type="text"
                                                    value={this.state.familyForm.name}
                                                    className="form-control form-control-sm"
                                                    autoComplete="off"
                                                    required={true}
                                                    onChange={(e) => this.formInputHandler(e, "familyForm")}
                                                    placeholder="Please enter Name"
                                                />
                                            </div>
                                            <div className="col-sm-2">
                                                <label htmlFor="relationship" className="form-label ">Relationship</label>
                                            </div>
                                            <div className="col-sm-4">
                                                <input
                                                    name="relationship"
                                                    type="text"
                                                    value={this.state.familyForm.relationship}
                                                    className="form-control form-control-sm"
                                                    autoComplete="off"
                                                    onChange={(e) => this.formInputHandler(e, "familyForm")}
                                                    placeholder="Please enter Relationship"
                                                />
                                            </div>
                                        </div>
                                        <div className="row align-items-center my-3">
                                            <div className="col-sm-2">
                                                <label htmlFor="dob" className="form-label">Date of Birth</label>
                                            </div>
                                            <div className="col-sm-4">
                                                <DatePicker
                                                    selected={
                                                        this.state.familyForm.dob
                                                            ? moment(this.state.familyForm.dob, 'YYYY-MM-DD').toDate()
                                                            : false
                                                    }
                                                    name="dob"
                                                    onChange={(value, event) => this.formDateHandler('dob', value, 'familyForm')}
                                                    dateFormat="dd-MMM-yyyy"
                                                    className={"form-control form-control-sm"}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    autoComplete="off"
                                                    scrollMonthYearDropdown
                                                    placeholderText={"Date of Birth"}
                                                />
                                                {/* <tapIcon.imageIcon icon={tapIcon.CalenderIcon} alt="From Date" className="add_calender-icon" /> */}
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" disabled={this.state.saveFormSubmitting ? true : false} className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                    <button type="submit" form="family-form" disabled={this.state.saveFormSubmitting ? true : false} className="btn btn-primary mx-2">
                                        Save {this.state.saveFormSubmitting ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : ''}
                                    </button>
                                </div>
                            </Ax>
                        }
                    </div>
                </div>
            </div>
        )
    }

}

const mapStateToProps = state => {
    return {
        access_token        :   state.auth.access_token,
        permissions         :   state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? state.app.acl_info.permissions : [],
    };
};


export default connect(mapStateToProps, null, null, { forwardRef: true })(EmployeeFamilyModal);